import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

export const relatedArticles: Record<
    CreditCardProductCategory,
    Array<{ href: string; subheading: string; title: string }>
> = {
    ['BalanceTransfer']: [
        {
            href: 'https://www.totallymoney.com/credit-cards/balance-transfer-credit-card/',
            subheading:
                'Find the right credit card for what you need – whether that’s paying off debt, spreading the cost of a purchase, or earning cashback when you spend.',
            title: 'Save money with a balance transfer credit card',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/money-transfer-credit-cards/',
            subheading:
                'Transfer cash to your bank account at 0% interest to clear expensive overdrafts and loans – cut your interest payments and simplify everything into one monthly repayment.',
            title: 'Cut your interest with a balance transfer card',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/best-credit-cards/',
            subheading:
                'Move your credit card debt to 0% interest and save money on charges – every penny you repay goes towards clearing what you owe instead of paying interest.',
            title: 'How to choose the right credit card',
        },
    ],

    ['BestCards']: [
        {
            href: 'https://www.totallymoney.com/credit-cards/balance-transfer-credit-card/',
            subheading:
                'Move expensive debt to a 0% card and save on interest - giving you more time to clear what you owe without extra charges piling up.',
            title: 'Save money with a balance transfer credit card',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/0-purchase-credit-card/',
            subheading:
                'Spread the cost of big purchases without paying interest for a set period - useful for managing larger expenses without stretching your budget.',
            title: 'Spread your costs with a 0% purchase credit card',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/cashback-credit-cards/',
            subheading:
                'Get money back when you spend - earn cash on your everyday purchases if you clear your balance in full each month.',
            title: 'Earn money with a cashback credit card',
        },
    ],

    ['Cashback']: [
        {
            href: 'https://www.totallymoney.com/credit-cards/cashback-credit-cards/',
            subheading:
                'Get paid to spend with a cashback card – you’ll earn money back on every purchase, which could add up to hundreds of pounds a year if you clear your balance each month.',
            title: 'Earn Money with a Cashback Credit Card',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/rewards-credit-card/',
            subheading:
                'Earn points on every purchase and exchange them for flights, shopping vouchers, or supermarket rewards – just make sure you pay off your balance in full to avoid interest wiping out your gains.',
            title: 'Getting the Most from Your Rewards Credit Card',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/best-credit-cards/',
            subheading:
                'Find the right credit card for what you need – whether that’s paying off debt, spreading the cost of a purchase, or earning cashback when you spend.',
            title: 'How to choose the right credit card',
        },
    ],

    ['Combined']: [
        {
            href: 'https://www.totallymoney.com/free-credit-report/how-improve-credit-score/',
            subheading:
                'Build a better credit score to access the longest 0% offers – make payments on time and keep balances low to unlock better balance transfer and purchase deals.',
            title: 'How to improve your credit score',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/section-75-consumer-credit-act/',
            subheading:
                'Understand your purchase protection rights – combination cards give you Section 75 coverage on purchases between £100-£30,000 if something goes wrong.',
            title: 'Section 75 protection explained',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/best-credit-cards/',
            subheading:
                'Find the right credit card for what you need – whether that’s clearing debt with a balance transfer, spreading costs with a purchase card, or both with a combination card.',
            title: 'Best credit cards',
        },
    ],

    ['PoorCredit']: [
        {
            href: 'https://www.totallymoney.com/free-credit-report/credit-score-range/',
            subheading:
                'Credit reference agencies calculate your credit score, a figure which gives potential lenders an indication of your creditworthiness.',
            title: 'Your credit score range explained',
        },

        {
            href: 'https://www.totallymoney.com/free-credit-report/how-improve-credit-score/',
            subheading:
                'Improving your credit score can help unlock better offers, so you can keep moving up towards your goals.',
            title: '7 ways to build your credit score',
        },

        {
            href: 'https://www.totallymoney.com/free-credit-report/rebuild-credit-score/',
            subheading:
                'Understanding how credit scoring works is the first step to fixing a bad score and improving your financial future.',
            title: 'How to fix a bad credit score',
        },
    ],

    ['Purchase']: [
        {
            href: 'https://www.totallymoney.com/credit-cards/why-use-a-purchase-card/',
            subheading:
                'Spread the cost of purchases interest-free instead of dipping into an expensive overdraft or taking out a loan – it’s a smarter way to buy what you need.',
            title: 'Why use a purchase card',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/0-purchase-credit-card/',

            subheading:
                'Make a big purchase and pay nothing in interest for months – you’ll spread the cost for free and get Section 75 payment protection.',

            title: 'Spread your costs with a 0% purchase credit card',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/best-credit-cards/',

            subheading:
                'Move your credit card debt to 0% interest and save money on charges – every penny you repay goes towards clearing what you owe instead of paying interest.',
            title: 'How to choose the right credit card',
        },
    ],

    ['Rewards']: [
        {
            href: 'https://www.totallymoney.com/free-credit-report/how-improve-credit-score/',
            subheading:
                'Build a better credit score to unlock the best rewards cards – make payments on time and keep your credit usage low to access better deals.',
            title: 'How to improve your credit score',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/section-75-consumer-credit-act/',
            subheading:
                'Understand your purchase protection rights – rewards cards give you Section 75 coverage on purchases between £100-£30,000 if something goes wrong.',
            title: 'Section 75 protection explained',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/best-credit-cards/',
            subheading:
                'Find the right credit card for what you need – whether that’s earning rewards, paying off debt, spreading costs, or spending abroad.',
            title: 'Best credit cards',
        },
    ],

    ['Travel']: [
        {
            href: 'https://www.totallymoney.com/credit-cards/overseas-travel-spending/',
            subheading:
                'Save money abroad with a travel credit card – avoid foreign transaction fees and get better exchange rates, plus Section 75 protection on your holiday bookings.',
            title: 'Travel credit cards',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/0-purchase-credit-card/',
            subheading:
                'Spread the cost of big purchases without paying interest for a set period – useful for paying off holiday costs over several months.',
            title: '0% purchase credit cards',
        },

        {
            href: 'https://www.totallymoney.com/credit-cards/best-credit-cards/',
            subheading:
                'Find the right credit card for what you need – whether that’s earning rewards, paying off debt, spreading costs, or spending abroad.',
            title: 'Best credit cards',
        },
    ],
}
